import { render, staticRenderFns } from "./AlarmListPanel.vue?vue&type=template&id=dedf8218&scoped=true"
import script from "./AlarmListPanel.vue?vue&type=script&lang=js"
export * from "./AlarmListPanel.vue?vue&type=script&lang=js"
import style0 from "./AlarmListPanel.vue?vue&type=style&index=0&id=dedf8218&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dedf8218",
  null
  
)

export default component.exports